import { createReducer, on } from '@ngrx/store';

import { LastViewedArticle } from '../models';

import { LastViewedArticlesActions } from './last-viewed-articles.actions';

export const lastViewedArticlesFeatureKey = 'mpms-core-last-viewed-articles';

export interface LastViewedArticlesState {
  lastViewedArticles: LastViewedArticle[];
}

export const initialState: LastViewedArticlesState = {
  lastViewedArticles: [],
};

export const lastViewedArticlesReducer = createReducer(
  initialState,
  on(
    LastViewedArticlesActions.fetchLastViewedArticles,
    (state): LastViewedArticlesState => ({
      ...state,
      lastViewedArticles: [],
    }),
  ),
  on(
    LastViewedArticlesActions.fetchLastViewedArticlesSuccess,
    (state, { lastViewedArticles }): LastViewedArticlesState => ({
      ...state,
      lastViewedArticles,
    }),
  ),
);
